export default {
  role: function() {
    return this.$store.state.session.user.roles[0]
  }
}
